
export const groupColumns = [
    {
        key: "group_name", label: 'groups.columns.name',
        componentTransform: (name: string, key: any,props:any) => {
            return <span key={`${key}-name`}>{props.group_name}</span>
        }
    },
    {
        key: "group_venues", label: 'groups.columns.venues',
        componentTransform: (name: string, key: any,props:any) => {
            return <span key={`${key}-name`} style={{paddingLeft:"0.3rem"}}>{props.venue_name}</span>
        }
    },
];